import { TFunction } from 'i18next'
import MssqlIndexingRestService from '../rest/MssqlIndexingRestService'

class MssqlIndexingService {
  static async enableIndex(policyId: number, t: TFunction) {
    try {
      await MssqlIndexingRestService.enableIndex(policyId)
      return t('mssqlAdapter.enableIndexSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async rebuildIndex(policyId: number, t: TFunction) {
    try {
      await MssqlIndexingRestService.rebuildIndex(policyId)
      return t('mssqlAdapter.rebuildIndexSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async disableIndex(policyId: number, t: TFunction) {
    try {
      await MssqlIndexingRestService.disableIndex(policyId)
      return t('mssqlAdapter.disableIndexSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MssqlIndexingService
